module.exports = __webpack_public_path__ + "static/media/member-token.69e877c7.svg";